/* 🤖 this file was generated by svg-to-ts */
export const matIconCallMissedOutgoing: {
  name: 'call-missed-outgoing';
  data: string;
} = {
  name: 'call-missed-outgoing',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m3 8.41 9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"/></svg>`
};
